
<template>
  <div>
    <dialog-loading loadingText="Baixando..." v-if="downloading"></dialog-loading>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="getPaymentResumePdf" v-bind="attrs" v-on="on" icon small :class="[['ml-1 mr-2'], [dark ? 'white primary--text' : 'primary white--text']]">
          <v-icon small>mdi-download</v-icon>
        </v-btn>
      </template>
      <span>Baixar PDF do pagamento</span>
    </v-tooltip>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DownloadPaymentResume',
  props: {
    payment_id: {
      type: [Number, String]
    },
    dark: {
      type: [Boolean],
      default: false,
    },
  },
  data(){
    return {
      downloading: false,
    }
  },
  methods: {
    getPaymentResumePdf(){
      this.downloading = true
      Api.Payment.payment_resume_pdf(this.payment_id).then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `resumo_do_pagamento.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href)
      }).finally(()=>{
        this.downloading = false
      })
    },
  },
}
</script>